
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key)))

//Vue.component('example-component', require('./components/ExampleComponent.vue'));

// Events observer
window.VueEvents = new Vue({});

require('magnific-popup');

// The 'namespace' for custom objects
import Init from './MrMovie/Init';
window.MrMovie = {
    init: new Init(),
};
MrMovie.init.init();

import BootstrapVue from 'bootstrap-vue';
import {YoutubeVideo} from "./MrMovie/YoutubeVideo";
window.YoutubeVideo = new YoutubeVideo();

Vue.use(BootstrapVue);

import * as VueGoogleMaps from 'vue2-google-maps';
import LazyLoad from "vanilla-lazyload";
let lazyLoad = new LazyLoad({
    elements_selector: ".lazy-load"
});

Vue.component('vue-google-map', VueGoogleMaps.Map);
Vue.component('vue-google-marker', VueGoogleMaps.Marker);
Vue.use(VueGoogleMaps, {
    load: {
        key: document.head.querySelector('meta[name="maps-api-key"]').content,
        installComponents: false,
        // libraries: ['places'],
    },
});

import VueRouter from 'vue-router';
const router = new VueRouter({
    mode: 'history',
});
Vue.use(VueRouter);


Vue.filter('kilometers', function (value) {
    let result = '';
    if(value < 1 ) {
        result += '< 1';
    } else {
        result += Math.round(value);
    }

    result += 'km';

    return result;
})


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */


const app = new Vue({
    router,
    el: '#app',
    data: {
        contentHtml: '',
    },
    mounted() {

        $(document).trigger('vue-ready');

        let filtersCollapsed = false;

        $(document).on('click', '.js-reset-show-filters', function() {
            filtersCollapsed = false;
            let $parent = $($(this).data('parent'));
            $parent.css({'height': ''});
        });

        $(document).on('click', '.js-show-filters', function() {

            let $parent = $($(this).data('parent'));

            if (filtersCollapsed) {
                filtersCollapsed = false;
                $parent.css({'height': ''});
            } else {
                $parent.animate({height: '100%'}, 200);
                filtersCollapsed = true;
            }
        });

        $(document).ready(function() {
            if (lazyLoad) {
                lazyLoad.update();
            }
        })

        //
        // VueEvents.$on('filters_locked', function(){
        //
        // });
        //
        // this.$forceUpdate();

        $.fn.isInViewport = function() {
            let elementTop = $(this).offset().top;
            let elementBottom = elementTop + $(this).outerHeight();
            let viewportTop = $(window).scrollTop();
            let viewportBottom = viewportTop + $(window).height();
            return elementBottom > viewportTop && elementTop < viewportBottom;
        };
    },
});

window.VueApp = app;



// WEBPACK FOOTER //
// ./resources/js/app.js